//
import AssetDiscountTypeModel from '@/models/HumanResource/HrAssetDiscountType'

//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default [
    {
        name: 'name',
        type: 'text-field',
        props: {
            label: 'Nombre',
            rules: [RequiredRule],
        },
    },
    {
        name: 'hr_asset_discount_type_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: AssetDiscountTypeModel,
            noObject: true,
            paramSearch: 'type',
            rules: [RequiredRule],
        },
    },
]
